import React from "react";
import { Card } from "@/components/ui/card";

function Kpi({ label, value, hint, tone = "", testId }) {
  return (
    <Card className={`p-4 border rounded-xl shadow-none ${tone || "border-stone-200"}`} data-testid={testId}>
      <div className="text-[11px] uppercase tracking-widest text-stone-500">{label}</div>
      <div className="text-2xl font-semibold mt-1 text-[#1C352D]">{value}</div>
      {hint && <div className="text-xs text-stone-500 mt-0.5">{hint}</div>}
    </Card>
  );
}

export function StatsKpis({ s }) {
  const fair = s.cv <= 15 ? ["Equilibrata", "border-emerald-200 bg-emerald-50/40"] : s.cv <= 30 ? ["Da migliorare", "border-amber-200 bg-amber-50/40"] : ["Squilibrata", "border-red-200 bg-red-50/40"];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      <Kpi label="Turni" value={s.turni} hint={`${s.hours} ore con orario`} testId="stats-kpi-turni"/>
      <Kpi label="Studenti" value={s.students} hint={`${s.with_turni} con almeno un turno`} testId="stats-kpi-students"/>
      <Kpi label="Media per studente" value={s.avg} hint={`± ${s.std} (deviazione)`} testId="stats-kpi-avg"/>
      <Kpi label="Minimo · Massimo" value={`${s.min} · ${s.max}`} hint={`scarto ${s.max - s.min}`} testId="stats-kpi-minmax"/>
      <Kpi label="Distribuzione" value={fair[0]} hint={`variabilità ${s.cv}%`} tone={fair[1]} testId="stats-kpi-fair"/>
      <Kpi label="Sostituzioni" value={s.substitutions} hint="per impegni esterni" testId="stats-kpi-subs"/>
    </div>
  );
}
